export default __webpack_public_path__ + "static/media/ad_search.9c9b5e47.svg";